import React, { useState } from "react";
import { Link } from 'react-router-dom';

function EnviarOferta() {
  const [form, setForm] = useState({
    puesto: "",
    empresa: "",
    email: "",
    descripcion: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("✅ ¡Gracias por enviar la oferta!");
    setForm({ puesto: "", empresa: "", email: "", descripcion: "" });
  };

  return (
    <>
      <div className="navbar">
        <div className="left">ArqueoJobs</div>
        <div className="right">
          <Link to="/enviar">Envía Oferta</Link>
          <Link to="/info">Info</Link>
          <Link to="/login">Login</Link>
        </div>
      </div>

      <div className="container">
        <Link to="/" className="volver">⬅ Volver</Link>
        <h1>✍️ Envía una oferta</h1>
        <form onSubmit={handleSubmit} className="cv-form">
          <input
            name="puesto"
            placeholder="Puesto"
            value={form.puesto}
            onChange={handleChange}
            required
          />
          <input
            name="empresa"
            placeholder="Empresa"
            value={form.empresa}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Correo de contacto"
            value={form.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="descripcion"
            placeholder="Descripción del trabajo"
            value={form.descripcion}
            onChange={handleChange}
            rows="5"
            required
          />
          <button type="submit">📤 Enviar Oferta</button>
        </form>
      </div>
    </>
  );
}

export default EnviarOferta;
